import React from 'react'
import './Slide.css'
import { Carousel } from 'antd';
// import Trainee from "./Images/student_robotics.jpg"
// import Basketball from "./Images/Basketball.jpg"
// import Ebsu from "./Images/ebsu_group.jpg"
// import Kids from "./Images/with_primary_kids.jpg"
// import Stairs from "./Images/stairsclimber.jpg"
// import Speech from "./Images/speech.jpg"

function Slide() {

  return (
    <div style={{height: "100%"}}>
    <Carousel  autoplay>
        <div className='Slide1'>
            <div className='overlay1'>
                <h1>Just Doodles</h1>
                <p>Owned by <strong>Prof...</strong></p>
            </div>
        </div>
        <div className='Slide2'>
            <div className='overlay2'>
                <h1>Kpako BC</h1>
                <p>Owned by <strong>CEO, KPAKO Wears</strong></p>
            </div>
        </div>
        <div className='Slide3'>
            <div className='overlay3'>
                <h1>Ringerz</h1>
                <p>Managed by <strong>Lase and friends</strong></p>
            </div>
        </div>
        <div className='Slide4'>
            <div className='overlay4'>
                <h1>Team Ace</h1>
                <p>Owned by <strong>Dr. Ayo (AKA Prof!)</strong></p>
            </div>
        </div>
        <div className='Slide5'>
            <div className='overlay5'>
                <h1>The Underdogs</h1>
                <p>Owned by <strong>Sanya (AKA San J)</strong></p>
            </div>
        </div>
        <div className='Slide6'>
            <div className='overlay6'>
                <h1>Travis Mavericks</h1>
                <p>Owned by <strong>Ugopreneur </strong></p>
            </div>
        </div>
        <div className='Slide7'>
            <div className='overlay7'>
                <h1>WildWest Ballers</h1>
                <p>Owned by <strong>Chase </strong></p>
            </div>
        </div>
    </Carousel>,
    </div>
  )
}

export default Slide